import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GeminiBatchService, GeminiBatchJob } from '@services/gemini-batch.service';

@Component({
    selector: 'app-gemini-batch-jobs',
    templateUrl: './gemini-batch-jobs.component.html',
    styleUrls: ['./gemini-batch-jobs.component.css']
})
export class GeminiBatchJobsComponent implements OnInit {
    jobs: GeminiBatchJob[] = [];
    loading = false;
    busyJobIds = new Set<number>();

    constructor(
        private geminiBatchService: GeminiBatchService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.loadJobs();
    }

    loadJobs(): void {
        this.loading = true;
        this.geminiBatchService.getJobs().subscribe({
            next: (data) => {
                this.jobs = data;
                this.loading = false;
            },
            error: () => {
                this.toastr.error('Job listesi yüklenirken hata oluştu', 'Hata');
                this.loading = false;
            }
        });
    }

    isBusy(jobId: number): boolean {
        return this.busyJobIds.has(jobId);
    }

    checkStatus(job: GeminiBatchJob): void {
        this.busyJobIds.add(job.id);
        this.geminiBatchService.checkStatus(job.id).subscribe({
            next: (updated) => {
                Object.assign(job, updated);
                this.toastr.success(`Durum: ${updated.status}`, 'Güncellendi');
                this.busyJobIds.delete(job.id);
            },
            error: () => {
                this.toastr.error('Durum kontrol edilirken hata oluştu', 'Hata');
                this.busyJobIds.delete(job.id);
            }
        });
    }

    fetchResults(job: GeminiBatchJob): void {
        this.busyJobIds.add(job.id);
        this.geminiBatchService.fetchResults(job.id).subscribe({
            next: (result) => {
                this.toastr.success(`${result.updatedCount} kelime güncellendi`, 'Sonuçlar getirildi');
                this.busyJobIds.delete(job.id);
                this.loadJobs();
            },
            error: (err) => {
                const message = err?.error || 'Sonuçlar getirilirken hata oluştu.';
                this.toastr.error(message, 'Hata');
                this.busyJobIds.delete(job.id);
            }
        });
    }
}
